import { render, staticRenderFns } from "./SketchDetailBox.vue?vue&type=template&id=5e1469d5&scoped=true"
import script from "./SketchDetailBox.vue?vue&type=script&lang=js"
export * from "./SketchDetailBox.vue?vue&type=script&lang=js"
import style0 from "./SketchDetailBox.vue?vue&type=style&index=0&id=5e1469d5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e1469d5",
  null
  
)

export default component.exports